import { useContext } from "react";
import GlobalContext from "@context/GlobalContext";

export default function usePermissoes() {
  const [state, dispatch] = useContext(GlobalContext);

  //Função de permissões.
  function handlePermissoes(id, compo = null, funcionalidades = null) {
    const permissoes = state.perfilselecionado || [];

    // Filtrar o app correspondente ao ID
    const app = permissoes?.filter((item) => item.idApp === id)[0];
    if (!app) return false; // Retorna falso se o app não for encontrado

    // Verificar apenas a visibilidade do app
    if (!compo && !funcionalidades) {
      return true;
    }

    // Verificar o compo específico
    if (compo && !funcionalidades) {
      const compos = app.Compo || {};
      return compo in compos;
    }

    // Verificar as funcionalidades do compo específico
    if (compo && funcionalidades) {
      const compos = app.Compo || {};
      const funcionalidadesCompo = compos[compo] || [];
      return funcionalidadesCompo.includes(funcionalidades);
    }
    return false; // Caso nenhuma condição seja atendida
  }

  return { handlePermissoes };
}
